import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPaymentSkeletonMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 367 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#fff" d="M0 0h367v256H0z" />
    <path fill="#fff" d="M8 8h351v116H8z" />
    <rect x={16.5} y={19.5} width={15} height={15} rx={7.5} stroke="#E6E6E6" />
    <path
      d="M38 27h252.5M18 42h333M18 58h333M18 74h333M18 90h333M18 106h204"
      stroke="#E6E6E6"
    />
    <path fill="#fff" d="M8 132h351v116H8z" />
    <rect x={16.5} y={143.5} width={15} height={15} rx={7.5} stroke="#E6E6E6" />
    <path
      d="M38 151h252.5M18 166h333M18 182h333M18 198h333M18 214h333M18 230h204"
      stroke="#E6E6E6"
    />
  </svg>
);
const Memo = memo(SvgPaymentSkeletonMobile);
export default Memo;
